import { useFrame } from '@react-three/fiber'
import React from 'react'
import { Euler, Group } from 'three'

export const TankDecorGroup3D: React.FC<{
  children: React.ReactNode
  xPivot?: boolean
  yPivot?: boolean
}> = ({ children, xPivot, yPivot }) =>
  xPivot ? (
    <XPivotDecorGroup3D>{children}</XPivotDecorGroup3D>
  ) : yPivot ? (
    <YPivotDecorGroup3D>{children}</YPivotDecorGroup3D>
  ) : (
    <>{children}</>
  )

const euler = new Euler()

const YPivotDecorGroup3D: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const ref = React.useRef<Group>(null)
  useFrame(({ camera }) => {
    if (!ref.current) return
    euler.set(0, Math.atan2(camera.position.x, camera.position.z), 0)
    ref.current.setRotationFromEuler(euler)
  })
  return <group ref={ref}>{children}</group>
}

const XPivotDecorGroup3D: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const ref = React.useRef<Group>(null)
  useFrame(({ camera }) => {
    if (!ref.current) return
    euler.set(
      Math.atan2(camera.position.z, camera.position.y) - Math.PI / 2.0,
      0,
      0
    )
    ref.current.setRotationFromEuler(euler)
  })
  return <group ref={ref}>{children}</group>
}
